module.exports = __webpack_public_path__ + "static/media/mizuni.259413ed.svg";